const FMT = new Intl.DateTimeFormat("en-u-ca-islamic-umalqura-nu-latn", { day: "numeric", month: "numeric" });
const hp = (d) => {
  const parts = FMT.formatToParts(d);
  return { m: Number(parts.find((p) => p.type === "month")?.value), day: Number(parts.find((p) => p.type === "day")?.value) };
};
// Saudi official holidays & occasions (Umm al-Qura for Hijri ones).
export const saHoliday = (d) => {
  const gm = d.getMonth() + 1, gd = d.getDate();
  if (gm === 2 && gd === 22) return { label: "يوم التأسيس", off: true };
  if (gm === 3 && gd === 11) return { label: "يوم العلم", off: false };
  if (gm === 9 && gd === 23) return { label: "اليوم الوطني", off: true };
  const { m, day } = hp(d);
  if (m === 1 && day === 1) return { label: "رأس السنة الهجرية", off: false };
  if (m === 9 && day === 1) return { label: "بداية رمضان", off: false };
  if (m === 9 && day >= 29) return { label: "إجازة عيد الفطر", off: true };
  if (m === 10 && day === 1) return { label: "عيد الفطر", off: true };
  if (m === 10 && day <= 4) return { label: "إجازة عيد الفطر", off: true };
  if (m === 12 && day === 9) return { label: "يوم عرفة", off: true };
  if (m === 12 && day === 10) return { label: "عيد الأضحى", off: true };
  if (m === 12 && day >= 11 && day <= 13) return { label: "إجازة عيد الأضحى", off: true };
  if (m === 9) return { label: "رمضان", off: false, soft: true };
  return null;
};
